(ns admin.events.containers.activity-settings
  "Responsible for bootstrapping the new-activity & edit-activity settings pages."
  (:require [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]))

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get activity settings page (Success)"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-success
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid]} res]]
  (let [curriculum (get res [:curriculum/uuid curriculum-uuid])
        activity (get res [:activity/uuid activity-uuid])]
    {:db (cond-> db
           (some? curriculum) (kyber-db/tx-record  {:model :curriculum} curriculum)
           (some? activity) (kyber-db/tx-record  {:model :activity} activity))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get activity settings page (Failure)"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get activity settings page"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [curriculum-uuid activity-uuid] :as params}]]
  {:db (cond-> db
           (some? curriculum-uuid)
           (kyber-db/retract-record {:model :curriculum} {:curriculum/uuid curriculum-uuid})
         
           (some? activity-uuid)
           (kyber-db/retract-record {:model :activity} {:activity/uuid activity-uuid}))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request
   (eql/request
    db
    {:name event-name
     :params (cond-> [{[:curriculum/uuid curriculum-uuid]
                       [:curriculum/uuid
                        :curriculum/name
                        :curriculum/compliance-enabled
                        {:curriculum/intro-activity
                         [:activity/uuid]}
                        {:curriculum/valid-tags
                         [:content-provider.tag-group/uuid
                          :content-provider.tag-group/name
                          {:content-provider.tag-group/values
                           [:content-provider.tag/uuid
                            :content-provider.tag/name]}]}]}]
               (some? activity-uuid)
               (conj {[:activity/uuid activity-uuid]
                      [:activity/uuid
                       :activity/name
                       :activity/allow-disabling-of-cbqs
                       :activity/allow-unmatched-graded-questions
                       :activity/published
                       :activity/ai-enabled
                       :activity/future-scrubbing-enabled
                       :activity/completion-threshold
                       :activity/completion-threshold-type
                       :activity/compliance-enabled
                       :activity/external-activity-link
                       :activity/description
                       :activity/is-supplemental?
                       :activity/note-taking-enabled
                       :activity/cme-front-matter-enabled
                       :activity/show-all-moments
                       :activity/poster
                       :activity/plo-type
                       {:activity/primary-learning-object
                        [:resource/uuid
                         :resource/duration
                         :resource/page-count
                         :resource/file-type
                         :resource/status]}
                       :activity/tile
                       :activity/cme-front-matter-url
                       {:activity/valid-tags
                        [:content-provider.tag-group/uuid
                         :content-provider.tag-group/name
                         {:content-provider.tag-group/values
                          [:content-provider.tag/uuid
                           :content-provider.tag/name
                           :content-provider.tag/is-supplemental?]}]}]}))
     :on-success [::fetch-container-data-success params]
     :on-failure [::fetch-container-data-failure params]})})

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-activity-settings
  ""
  (partial ensure-resource-v2 ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))
